import React from "react";
import FormControl from "@material-ui/core/FormControl";
import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton/IconButton";
import Input from "@material-ui/core/Input";
import InputAdornment from "@material-ui/core/InputAdornment";

class FilterForm extends React.Component {

    constructor(props) {
        super(props);

        this.state = {filter: props.filter || ''};
    }

    handleFilterChange = (e) => {
        this.setState({filter: e.target.value});
    };

    render() {
        const {url, inputPlaceholder, buttonTitle} = this.props;

        return (
            <form
                method="GET"
                action={url}
            >
                <FormControl>
                    <Input
                        type="text"
                        name="filter"
                        placeholder={inputPlaceholder}
                        value={this.state.filter}
                        onChange={this.handleFilterChange}
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    title={buttonTitle}
                                    type="submit"
                                >
                                    <Icon>search</Icon>
                                </IconButton>
                            </InputAdornment>
                        }
                    />
                </FormControl>
            </form>
        );
    }
}

export default FilterForm;
